export const categoryNormalize = (category: string) => {
  return category
    ? encodeURIComponent(category.replaceAll(/\//g, "--"))
    : category;
};

export const categoryUnformat = (categoryNormalized: string) => {
  return categoryNormalized?.replaceAll(/--/g, "/") || categoryNormalized;
};
